import { Address, AggregatedStatus, RoleGroupType, UserRoleType } from '../../models';

export enum InvitationAccessLevel {
  BuildingManager = 'BuildingManager',
  Owner = 'Owner',
  FamilyMember = 'FamilyMember',
  Maintainer = 'Maintainer',
  Support = 'Support',
  Installer = 'Installer',
  ServiceContractor = 'ServiceContractor',
  Operator = 'Operator',
  CommercialOwner = 'CommercialOwner',
  Partner = 'Partner',
  Consumer = 'Consumer',
}

export enum InvitationStatusType {
  Pending = 'Pending',
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  Canceled = 'Canceled',
  Expired = 'Expired',
  Terminated = 'Terminated',
}

export enum InvitationTokenType {
  Invited = 'Invited',
  Requested = 'Requested',
}

export interface InvitationCompany {
  billingCity: string;
  billingPostalCode: string;
  billingStreet: string;
  country: string;
  customerNumber: string;
  email: string;
  language: string;
  name: string;
  phoneNumber: string;
}

export interface InvitationUser {
  businessPartnerId: string;
  companyName?: string;
  company: InvitationCompany;
  createdAt: string;
  editedAt: string;
  email: string;
  emailVerified: boolean;
  firstName: string;
  group: string;
  isDeleted: boolean;
  lastName: string;
  locale: string;
  mobileNumber: string;
  role: string;
  salutationV2: string;
  viAccount: string;
}

export interface Invitation {
  accessLevel: InvitationAccessLevel;
  buildingGroupId?: number | string;
  buildingId?: number | string;
  comment?: string;
  createdAt: string;
  companyName?: string;
  customerNumber: string;
  editedAt: string;
  editedByAccount: string;
  installationId: number;
  invitee?: InvitationUser;
  inviter?: InvitationUser;
  inviteeAccount: string;
  inviteeEmail?: string;
  inviterAccount: string;
  status: InvitationStatusType;
  token: string;
  tokenExpirationDate: string;
  tokenType: InvitationTokenType;
  inviterCompanyName?: string;
  inviterCustomerNumber?: string;
  ownedByMaintainer?: boolean;
  index?: number;
  isVisible?: boolean;
}

export interface InvitationsQueryParams {
  status?: InvitationStatusType | InvitationStatusType[];
  accessLevel?: string;
  customerNumber?: string;
  installationId?: number | string;
  expanded?: boolean;
  limit?: number;
  offset?: number;
}

export interface InvitationInstallationDetails {
  id: number | string;
  description: string;
  address: any;
  gateways: any[];
  registeredAt: string;
  updatedAt: string;
  aggregatedStatus: AggregatedStatus;
  servicedBy: string;
}

export interface InvitationOwnerDetails {
  viAccount: string;
  salutation: string;
  firstName: string;
  lastName: string;
  email: string;
  mobileNumber: string;
  phoneNumber: string;
  faxNumber: string;
  locale: string;
  workCountry: string;
  address: Address;
  role: UserRoleType;
  roleGroup: RoleGroupType;
  group: string;
  createdAt: string;
  editedAt: string;
  isDeleted: boolean;
}

export interface InvitationCompanyDetails {
  id: string;
  companyName: string;
  website: string;
}

export interface CreateInvitationRequest {
  installationId?: string | number;
  gatewaySerial?: string;
  buildingId?: number;
  buildingGroupId?: number;
  isInstallationBounded?: boolean;
  comment?: string;
  inviteeEmail?: string;
  accessLevel?: InvitationAccessLevel;
}

export interface CreateInvitationToTransferOwnershipRequest {
  installationId: number;
  inviteeEmail: string;
}

export interface UpdateInvitationRequest {
  status: InvitationStatusType;
  buildingId?: number;
  buildingGroupId?: number;
  onBehalfOf?: string;
}

export interface CommercialInvitation {
  firstName: string;
  lastName: string;
  street: string;
  houseNumber: string;
  zip: string;
  city: string;
  phoneNumber: string;
  note?: string;
  status: InvitationStatusType;
}
